/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online unit converter — length, weight, temperature, volume, area, speed, data and time. Instant, accurate conversions. No signup.`)
};

const es_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de unidades en línea gratuito — longitud, peso, temperatura, volumen, área, velocidad, datos y tiempo. Conversiones instantáneas y precisas. Sin registro.`)
};

const de_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Einheitenumrechner — Länge, Gewicht, Temperatur, Volumen, Fläche, Geschwindigkeit, Daten und Zeit. Sofortige, präzise Umrechnungen. Keine Anmeldung erforderlich.`)
};

const nl_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online eenheidconverter — lengte, gewicht, temperatuur, volume, oppervlakte, snelheid, gegevens en tijd. Onmiddellijke, nauwkeurige conversies. Geen registratie vereist.`)
};

const fr_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur d'unités gratuit en ligne — longueur, poids, température, volume, superficie, vitesse, données et temps. Conversions instantanées et précises. Aucune inscription requise.`)
};

const it_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di unità online gratuito — lunghezza, peso, temperatura, volume, area, velocità, dati e tempo. Conversioni istantanee e accurate. Nessuna iscrizione.`)
};

const pt_br2_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de unidades online gratuito — comprimento, peso, temperatura, volume, área, velocidade, dados e tempo. Conversões instantâneas e precisas. Sem necessidade de inscrição.`)
};

const pt_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de unidades online gratuito — comprimento, peso, temperatura, volume, área, velocidade, dados e tempo. Conversões instantâneas e precisas. Sem necessidade de registo.`)
};

const ja_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインユニットコンバーター — 長さ、質量、温度、体積、面積、速度、データ、時間。即座で正確な変換。サインアップ不要。`)
};

const zh_uc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线单位换算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_tool_description", locale)
	if (locale === "en") return en_uc_tool_description(inputs)
	if (locale === "es") return es_uc_tool_description(inputs)
	if (locale === "de") return de_uc_tool_description(inputs)
	if (locale === "nl") return nl_uc_tool_description(inputs)
	if (locale === "fr") return fr_uc_tool_description(inputs)
	if (locale === "it") return it_uc_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_uc_tool_description(inputs)
	if (locale === "pt") return pt_uc_tool_description(inputs)
	if (locale === "ja") return ja_uc_tool_description(inputs)
	return zh_uc_tool_description(inputs)
};